import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingSpinner from '../partials/LoadingSpinner';

import ItemLine from './ItemLine';
import AddSupplierAssignmentModal from './AddSupplierAssignmentModal';
import UpdateSupplierAssignmentModal from './UpdateSupplierAssignmentModal';
import DeleteSupplierAssignmentModal from './DeleteSupplierAssignmentModal';
import ShowOtherSuppliersModal from './ShowOtherSuppliersModal';
import InventoryDetailsModal from './InventoryDetailsModal';

import { Button, Text, H2, H4, Panel, Dropdown, Small, Search, Collapse, Box, Switch, Pagination, Input } from '@bigcommerce/big-design';
import { ArrowDropDownIcon } from '@bigcommerce/big-design-icons';

import { searchProducts, inventoryDetails } from '../../redux/actions/products';
import { getCategories } from '../../redux/actions/categories';

const ProductSearch = ({ payload, activeSupplier, activeShippingAddress, isSearching, searchedProducts, searchedProductsPagination, searchedVariants, categories, submitSearch, loadCategories, createAssignments, searchedProductsMetafields, searchedVariantsMetafields, getInventoryDetails }) => {
  const [submitted, setSubmitted] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [inStockFilter, setInStockFilter] = useState(false);
  const [purchasingDisabledFilter, setPurchasingDisabledFilter] = useState(false);
  const [categoryFilter, setCategoryFilter] = useState();
  const [enqueueSearch, setEnqueueSearch] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const [showAddSupplierAssignmentModal, setShowAddSupplierAssignmentModal] = useState(false);
  const [showUpdateSupplierAssignmentModal, setShowUpdateSupplierAssignmentModal] = useState(false);
  const [showDeleteSupplierAssignmentModal, setShowDeleteSupplierAssignmentModal] = useState(false);
  const [showOtherSuppliersModal, setShowOtherSuppliersModal] = useState(false);

  const [modalProductId, setModalProductId] = useState(null);
  const [modalVariantId, setModalVariantId] = useState(null);
  const [modalOptions, setModalOptions] = useState(null);
  const [modalProductName, setModalProductName] = useState(null);
  const [modalType, setModalType] = useState(null);
  const [modalAssignment, setModalAssignment] = useState(null);

  const [showInventoryDetailsModal, setShowInventoryDetailsModal] = useState(false);
  const [activeProductId, setActiveProductId] = useState(null);
  const [activeVariantId, setActiveVariantId] = useState(null);

  useEffect(() => {
    loadCategories(payload);
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if(searchTerm !== ''){
        setCurrentPage(1);
        handleSearch(searchTerm, 1);
      }
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchTerm, 500]);

  const handleSearch = (searchTerm, page) => {
    if(!isSearching) {
      setEnqueueSearch(null);
      submitSearch(payload, searchTerm, inStockFilter, purchasingDisabledFilter, categoryFilter, page);
    } else {
      setEnqueueSearch(searchTerm);
    }
  }

  useEffect(() => {
    if(!isSearching) {
      readySearch();
    }
  }, [isSearching]);

  const readySearch = () => {
    if(enqueueSearch) {
      submitSearch(payload, enqueueSearch, inStockFilter, purchasingDisabledFilter, categoryFilter, currentPage);
      setEnqueueSearch(null);
    }
  }

  const findAssignment = (assignments) => {
    if(assignments.length === 0){
      return null;
    }

    let supplierAssignment = assignments.find(assignment => assignment.key === `Supplier-${activeSupplier.id}` );

    return supplierAssignment;
  }

  const toggleInStockFilter = () => {
    setInStockFilter(!inStockFilter);
  }

  const togglePurchasingDisabledFilter = () => {
    setPurchasingDisabledFilter(!purchasingDisabledFilter);
  }

  const categoryItems = () => {
    let items = [];

    Object.entries(categories.categories).map(([key, name]) =>
      items.push(
        {
          content: name,
          onItemClick: (event) => switchCategoryFilter(event, setCategoryFilter),
          hash: key
        }
      )
    )

    return items;
  }

  const switchCategoryFilter = (event, setter) => {
    let categoryId = event.hash;
    setter(categoryId);
  }

  const setProductResultPage = (page) => {
    setCurrentPage(page);
    handleSearch(searchTerm, page);
  }

  const clearCategory = () => {
    setCategoryFilter(null);
  }

  const validateTerm = (event) => {
    let value = event.target.value;

    setSearchTerm(value);
  }
  
  const validatePage = (event) => {
    let page = event.target.value;

    if (page < 1) {
      page = 1;
    }

    if (page > searchedProductsPagination.total_pages) {
      page = searchedProductsPagination.total_pages;
    }

    setCurrentPage(page);
  }

  const showInventoryModal = (inventoryTracking, lineProductId, lineItemId) => {
    let productId = null;
    let variantId = null;

    if(inventoryTracking === 'variant') {
      productId = lineProductId;
      variantId = lineItemId;
      setActiveProductId(lineProductId);
      setActiveVariantId(lineItemId);
    } else {
      productId = lineProductId;
      variantId = null;
      setActiveProductId(lineProductId);
      setActiveVariantId(null);
    }

   getInventoryDetails(payload, productId, variantId);
   setShowInventoryDetailsModal(true);
  }

  const submitPage = () => {
    handleSearch(searchTerm, currentPage);
  }

  const handleSubmit = () => {
    setSubmitted(true);
    createAssignments(payload, activeSupplier.id, selectedProductList, assignmentValues);
  }

  return(
    <>
      <Panel>
        <div className="full-width">
          <Box marginBottom="medium">
            <H4>Catalog Search</H4>
            <Search onChange={validateTerm} onSubmit={() => handleSearch(searchTerm)} value={searchTerm} />
            <Collapse title="Filters">
              <div className="background-darken padding-20 flex-container">
                <div className="flex-1">
                  <H4>In Stock</H4>
                  <Switch checked={inStockFilter} onChange={toggleInStockFilter} />
                </div>
                <div className="flex-1">
                  <H4>Purchasing Disabled</H4>
                  <Switch checked={purchasingDisabledFilter} onChange={togglePurchasingDisabledFilter} />
                </div>
                <div className="flex-2">
                  <H4>Cagetory</H4>
                  { !categories.isFetching && categories.status === "success" &&
                    <>
                      <Dropdown
                        items={categoryItems()}
                        maxHeight={250}
                        placement="bottom-start"
                        toggle={<Button iconRight={<ArrowDropDownIcon />}>{categories.categories[categoryFilter] || "Select Category"}</Button>}
                      />
                      <Button variant="subtle" className="left-15 bottom-5" onClick={() => clearCategory()}>
                        Clear Category
                      </Button>
                    </>
                  }
                  { categories.isFetching &&
                    <LoadingSpinner size="xxSmall" statusText="Loading categories"/>
                  }
                </div>
              </div>
              <hr/>
            </Collapse>
          </Box>
        </div>

      </Panel>


      <Panel>
        { !isSearching && searchedProducts === null && searchTerm === '' &&
          <Box
            backgroundColor="primary20"
            border="box"
            borderRadius="normal"
            padding="medium"
          >
            <H4>Search Results</H4>
            <Text>
              Search your store's catalog above to see live results here
            </Text>
          </Box>
        }

        { isSearching && <LoadingSpinner size="small" statusText="Searching products" /> }

        { !isSearching && searchedProducts !== null && 
          <>
            <div>
              { searchedProductsPagination.total_pages > 1 &&
                <div className="flex-container">
                  <div className="flex-1">
                    <Pagination
                      currentPage={searchedProductsPagination.current_page}
                      itemsPerPage={50}
                      itemsPerPageOptions={[]}
                      onItemsPerPageChange={null}
                      onPageChange={(newPage) => setProductResultPage(newPage)}
                      totalItems={searchedProductsPagination.total}
                    />
                  </div>
                  <div className="flex-1">
                    <div className="flex-container">
                      <div className="flex-1">
                        <div className="right-15">
                          <Input
                            required
                            onChange={validatePage}
                            placeholder="Page"
                            value={currentPage}
                            type="number"
                          />
                        </div>
                      </div>

                      <div className="flex-8">
                        <Text as="span">
                          of {searchedProductsPagination.total_pages} pages &nbsp;
                        </Text>

                        <Button className="left-15" onClick={() => submitPage()}>Set Page</Button>
                      </div>
                    </div>
                  </div>
                </div>
              }

              { searchedProducts?.map(product => 
                <>
                  <ItemLine
                    payload={payload}
                    type={'product'}
                    productId={product.id}
                    itemId={product.id}
                    options={false}
                    name={product.name}
                    imageUrl={product.primary_image?.url_tiny}
                    fullImageUrl={product.primary_image?.url_standard}
                    rowId={product.id}
                    price={product.price}
                    quantity={product.inventory_level}
                    inventoryTracking={product.inventory_tracking}
                    hasVariants={searchedVariants[product.id]?.length > 0}
                    binPickingNumber={product.bin_picking_number}
                    sku={product.sku}
                    upc={product.upc}
                    assignments={searchedProductsMetafields[product.id] ? searchedProductsMetafields[product.id]['data'] : null}
                    assignment={searchedProductsMetafields[product.id] ? findAssignment(searchedProductsMetafields[product.id]['data']) : null}
                    setModalProductId={setModalProductId}
                    setModalVariantId={setModalVariantId}
                    setModalOptions={setModalOptions}
                    setModalProductName={setModalProductName}
                    setModalType={setModalType}
                    setModalAssignment={setModalAssignment}
                    setShowAddSupplierAssignmentModal={setShowAddSupplierAssignmentModal}
                    setShowUpdateSupplierAssignmentModal={setShowUpdateSupplierAssignmentModal}
                    setShowDeleteSupplierAssignmentModal={setShowDeleteSupplierAssignmentModal}
                    setShowOtherSuppliersModal={setShowOtherSuppliersModal}
                    activeSupplier={activeSupplier}
                    showInventoryModal={showInventoryModal}
                    activeShippingAddress={activeShippingAddress}
                  />
                  { searchedVariants[product.id]?.map(variant =>
                    <ItemLine
                      payload={payload}
                      type={'variant'}
                      productId={product.id}
                      itemId={variant.id}
                      name={product.name}
                      imageUrl={product.primary_image?.url_tiny}
                      fullImageUrl={product.primary_image?.url_standard}
                      options={variant.option_values}
                      price={variant.price || product.price}
                      quantity={variant.inventory_level}
                      inventoryTracking={'variant'}
                      hasVariants={false}
                      binPickingNumber={variant.bin_picking_number}
                      sku={variant.sku}
                      upc={variant.upc}
                      assignments={searchedVariantsMetafields[product.id + '/' + variant.id] ? searchedVariantsMetafields[product.id + '/' + variant.id]['data'] : null}
                      assignment={searchedVariantsMetafields[product.id + '/' + variant.id] ? findAssignment(searchedVariantsMetafields[product.id + '/' + variant.id]['data']) : null}
                      setModalProductId={setModalProductId}
                      setModalVariantId={setModalVariantId}
                      setModalOptions={setModalOptions}
                      setModalProductName={setModalProductName}
                      setModalType={setModalType}
                      setModalAssignment={setModalAssignment}
                      setShowAddSupplierAssignmentModal={setShowAddSupplierAssignmentModal}
                      setShowUpdateSupplierAssignmentModal={setShowUpdateSupplierAssignmentModal}
                      setShowDeleteSupplierAssignmentModal={setShowDeleteSupplierAssignmentModal}
                      setShowOtherSuppliersModal={setShowOtherSuppliersModal}
                      activeSupplier={activeSupplier}
                      showInventoryModal={showInventoryModal}
                      activeShippingAddress={activeShippingAddress}
                    />
                  )}
                </>
              )}
            </div>
          </>
        }


      </Panel>

      { showAddSupplierAssignmentModal && 
        <AddSupplierAssignmentModal
          payload={payload}
          showAddSupplierAssignmentModal={showAddSupplierAssignmentModal}
          setShowAddSupplierAssignmentModal={setShowAddSupplierAssignmentModal}
          supplier={activeSupplier}
          modalProductId={modalProductId}
          modalVariantId={modalVariantId}
          modalOptions={modalOptions}
          modalProductName={modalProductName}
          modalType={modalType}
        />
      }


      { showUpdateSupplierAssignmentModal && 
        <UpdateSupplierAssignmentModal
          payload={payload}
          showUpdateSupplierAssignmentModal={showUpdateSupplierAssignmentModal}
          setShowUpdateSupplierAssignmentModal={setShowUpdateSupplierAssignmentModal}
          supplier={activeSupplier}
          modalProductId={modalProductId}
          modalVariantId={modalVariantId}
          modalOptions={modalOptions}
          modalProductName={modalProductName}
          modalType={modalType}
          modalAssignment={modalAssignment}
        />
      }

      { showDeleteSupplierAssignmentModal &&
        <DeleteSupplierAssignmentModal
          payload={payload}
          showDeleteSupplierAssignmentModal={showDeleteSupplierAssignmentModal}
          setShowDeleteSupplierAssignmentModal={setShowDeleteSupplierAssignmentModal}
          supplier={activeSupplier}
          modalProductId={modalProductId}
          modalVariantId={modalVariantId}
          modalOptions={modalOptions}
          modalProductName={modalProductName}
          modalType={modalType}
          modalAssignment={modalAssignment}
        />
      }

      { showOtherSuppliersModal && searchedVariantsMetafields && searchedVariantsMetafields[`${modalProductId}/${modalVariantId}`] && (searchedVariantsMetafields[`${modalProductId}/${modalVariantId}`]?.data.filter(assignment => assignment.key !== `Supplier-${activeSupplier?.id}`).length > 0) && 
        <ShowOtherSuppliersModal
          showOtherSuppliersModal={showOtherSuppliersModal}
          setShowOtherSuppliersModal={setShowOtherSuppliersModal}
          activeSupplier={activeSupplier}
          modalProductId={modalProductId}
          modalVariantId={modalVariantId}
          modalOptions={modalOptions}
          modalProductName={modalProductName}
          modalType={modalType}
          modalAssignment={modalAssignment}
        />
      }

      <InventoryDetailsModal
        payload={payload}
        showInventoryDetailsModal={showInventoryDetailsModal}
        setShowInventoryDetailsModal={setShowInventoryDetailsModal}
        productId={activeProductId}
        variantId={activeVariantId}
      />
    </>
  )
}

const mapStateToProps = state => ({
  isSearching: state.products.isFetching,
  searchedProducts: state.products.searchedProducts,
  searchedProductsPagination: state.products.searchedProductsPagination,
  searchedVariants: state.products.searchedVariants,
  searchedProductsMetafields: state.products.searchedProductsMetafields,
  searchedVariantsMetafields: state.products.searchedVariantsMetafields,
  categories: state.categories
});

const mapDispatchToProps = (dispatch) => ({
  submitSearch: (payload, searchTerm, inStockFilter, purchasingDisabledFilter, categoryFilter, page) => dispatch(searchProducts(payload, searchTerm, inStockFilter, purchasingDisabledFilter, categoryFilter, page)),
  loadCategories: (payload) => dispatch(getCategories(payload)),
  // createAssignments: (payload, supplierId, assignments, assignmentValues) => dispatch(assignmentsCreate(payload, supplierId, assignments, assignmentValues)),
  getInventoryDetails: (payload, productId, variantId) => dispatch(inventoryDetails(payload, productId, variantId)),

});

export default connect(mapStateToProps, mapDispatchToProps)(ProductSearch);
